"use strict";
/**
 * Rate conversions and small numeric helpers for the retirement engine.
 *
 * We deliberately convert annual → monthly via effective compounding:
 *   monthly = (1 + annual) ^ (1/12) − 1
 * NOT the naive `annual / 12`. This keeps the compounded 12-month
 * result equal to the stated annual return.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.round = exports.clamp = exports.safeDivide = exports.monthlyGrowthFactor = exports.effectiveAnnualToMonthly = void 0;
function effectiveAnnualToMonthly(annualRate) {
    if (annualRate <= -1)
        return -1;
    return Math.pow(1 + annualRate, 1 / 12) - 1;
}
exports.effectiveAnnualToMonthly = effectiveAnnualToMonthly;
/** Compound growth factor for `months` at the given monthly rate. */
function monthlyGrowthFactor(monthlyRate, months) {
    return Math.pow(1 + monthlyRate, months);
}
exports.monthlyGrowthFactor = monthlyGrowthFactor;
/** Safe division that returns `fallback` on non-finite results. */
function safeDivide(numerator, denominator, fallback = 0) {
    if (!Number.isFinite(numerator) || !Number.isFinite(denominator) || denominator === 0) {
        return fallback;
    }
    return numerator / denominator;
}
exports.safeDivide = safeDivide;
/** Clamp x into [min, max]. */
function clamp(x, min, max) {
    return Math.min(max, Math.max(min, x));
}
exports.clamp = clamp;
/** Round to `dp` decimal places, half-away-from-zero. */
function round(x, dp = 0) {
    const f = Math.pow(10, dp);
    return Math.sign(x) * Math.round(Math.abs(x) * f) / f;
}
exports.round = round;
